export default __webpack_public_path__ + "static/media/d_proposal.93b6c295.avif";